/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'copy': {
    width: 16,
    height: 16,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M394.667 106.667h448a74.667 74.667 0 0174.666 74.666v448A74.667 74.667 0 01842.667 704h-448A74.667 74.667 0 01320 629.333v-448a74.667 74.667 0 0174.667-74.666zm0 64A10.667 10.667 0 00384 181.333v448A10.667 10.667 0 00394.667 640h448a10.667 10.667 0 0010.666-10.667v-448a10.667 10.667 0 00-10.666-10.666h-448zM640 768a32 32 0 0164 0v74.667a74.667 74.667 0 01-74.667 74.666h-448a74.667 74.667 0 01-74.666-74.666v-448A74.667 74.667 0 01181.333 320H256a32 32 0 010 64h-74.667a10.667 10.667 0 00-10.666 10.667v448a10.667 10.667 0 0010.666 10.666h448A10.667 10.667 0 00640 842.667V768z"/>'
  }
})
